import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import BreadcrumbList from '@ucheba/ui/components/BreadcrumbList/desktop'
import Img from '../assets/img__offer-messages.png'
import { IIndexEgePageProps, ETypeRequest } from '../types'
import ImgBg from '../assets/img__offer-1_desktop.png'
import { EApplicationFormProductTypes } from '../../../../../components/AppliactionForm/types'
import ImgTopLeft from '../assets/img__form2_left_top_desktop.png'
import ImgTopRight from '../assets/img__form2_right_top_desktop.png'
import SchoolForm from '../../../../../components/Blocks/SchoolForm/desktop'

const TopLeft = styled.img`
  position: absolute;
  top: -120px;
  width: 120px;
  left: 0;
  z-index: 1;
`

const TopRight = styled.img`
  position: absolute;
  top: -120px;
  width: 120px;
  right: 0;
  z-index: 1;
`

const IndexEgePageForm2: FC<
  IIndexEgePageProps['content']['offer'] & {
    // eslint-disable-next-line react/require-default-props
    breadcrumbList?: {
      name: string
      href: string
    }
    // eslint-disable-next-line react/require-default-props
    totalDiscount?: number
  }
> = (props) => {
  const { title, breadcrumbList, totalDiscount } = props

  const list = useMemo(() => {
    if (breadcrumbList) return breadcrumbList

    return [
      {
        name: 'На главную',
        href: '/',
      },
      {
        name: 'Подготовка к ЕГЭ',
        href: '/for-abiturients/ege',
      },
    ]
  }, [breadcrumbList])

  return (
    <SchoolForm
      title={title.desktop}
      img={Img}
      bgImg={ImgBg}
      productType={EApplicationFormProductTypes.ege}
      requestTarget={ETypeRequest.ege_lead_request}
      elements={<BreadcrumbList justifyContent='center' color='white50' list={list} />}
      buttonColor='pink'
      totalDiscount={totalDiscount}
    >
      <TopLeft src={ImgTopLeft} />
      <TopRight src={ImgTopRight} />
    </SchoolForm>
  )
}

export default IndexEgePageForm2
